import { Box } from '@mui/material';

const CardWrapper = (props) => {
    const { children, sx, ...boxProps } = props;
    const sxOverrides = Array.isArray(sx) ? sx : sx ? [sx] : [];

    return (
        <Box
            {...boxProps}
            sx={[
                { display: 'flex', width: '95%', borderRadius: 2, background: '#F8F8F8', boxShadow: 1, py: 1, px: 2, marginTop: '-15px' },
                ...sxOverrides
            ]}
        >
            {children}
        </Box>
    );
};

export default CardWrapper;
